module.exports = __webpack_public_path__ + "img/compress.3a221289.webp";